module.exports = __webpack_public_path__ + "static/ChillTube-46dfdd24925944ba2e4c99940e30582a.png";